<div class="mb-37 mct-flex mct-row mct-justify-between mct-items-center"   data-pendo="lineItemHeader">
  <span class="f-wb">{{ lineItem.Item }} {{ lineItem.LineItemId ? '(' + lineItem.LineItemId + ')' : '' }}</span>
  <span>
    {{ 'revenue.invoice-line-item-details.line-item-amount' | translate | ucfirst }}:
    <strong class="ml-10">{{ lineItem.Amount | atlasCurrency }}</strong>
  </span>
</div>

<div [@slideReveal]="isExpanded ? 'revealed' : 'hidden'">
  <div class="mct-flex mct-col mct-gap-27"  >
    <div *ngIf="lineItem.Adjustments?.length">
      <label class="light-text">{{ 'revenue.invoice-line-item-details.line-item-adjustments' | translate | ucfirst }}</label>
      <div class="mct-flex mct-row mct-justify-between mct-items-center" *ngFor="let adjustment of lineItem.Adjustments"  >
        <div>
          <span>{{ adjustment.AdjustmentType }} </span>
          <span *ngIf="adjustment.AdjustmentId">({{ adjustment.AdjustmentId }}) </span>
          <span>{{ adjustment.AdjustmentDate | date: 'M/dd/yyyy' }}</span>
        </div>
        <div>{{ adjustment.AdjustmentAmount | atlasCurrency }}</div>
      </div>
    </div>

    <div *ngIf="lineItem.Payments?.length">
      <label class="light-text">{{ 'revenue.invoice-line-item-details.payments' | translate | ucfirst }}</label>
      <div class="mct-flex mct-row mct-justify-between mct-items-center" *ngFor="let payment of lineItem.Payments"  >
        <div>
          <span>{{ payment.PaymentType }} </span>
          <span *ngIf="payment.PaymentID">({{ payment.PaymentID }}) </span>
          <span>{{ payment.PaymentDate | date: 'M/dd/yyyy' }}</span>
        </div>
        <div>{{ payment.Amount | atlasCurrency }}</div>
      </div>
    </div>

    <div *ngIf="hasPaymentAdjustments">
      <label class="light-text">{{ 'revenue.invoice-line-item-details.payment-adjustments' | translate | ucfirst }}</label>
      <div *ngFor="let payment of lineItem.Payments">
        <div class="mct-flex mct-row mct-justify-between mct-items-center" *ngFor="let adjustment of payment.Adjustments"  >
          <div>
            <span>{{ adjustment.AdjustmentType }} </span>
            <span *ngIf="adjustment.AdjustmentId">({{ adjustment.AdjustmentId }}) </span>
            <span>{{ adjustment.AdjustmentDate | date: 'M/dd/yyyy' }}</span>
          </div>
          <div>{{ adjustment.AdjustmentAmount | atlasCurrency }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-37 mb-27 mct-flex mct-row mct-justify-between mct-items-center"  >
    <strong>{{ 'revenue.invoice-line-item-details.line-item-adjusted-amount-due' | translate | ucfirst }}:</strong>
    <div>
      <span>{{ 'revenue.invoice-line-item-details.amount-due' | translate | ucfirst }}:</span>
      <strong class="ml-10">{{ adjustedAmountDue | atlasCurrency }}</strong>
    </div>
  </div>
</div>

<div class="expand-button">
  <a (click)="isExpanded = !isExpanded">
    {{ isExpanded ? ('common.collapse' | translate | ucfirst) : ('common.expand' | translate | ucfirst) }}
    <i *ngIf="isExpanded" class="pi pi-caret-up"></i>
    <i *ngIf="!isExpanded" class="pi pi-caret-down"></i>
  </a>
</div>
